import React, {useEffect, useState} from "react";
import { useNavigate } from 'react-router-dom';
import SimpleBar from 'simplebar-react';
import axios from 'axios';
import { useBaseUrlContext } from "../context/Base_url";
import { useAlertContext } from "../context/Alerts";
import { useJobDetailContext } from "../context/Job_details.js";
import { useQuery, useInfiniteQuery } from "@tanstack/react-query";
import { useErrHandleContext } from "../context/Err_handle.js";

import {ThemeProvider, Container, Typography} from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2'; 
import { ThemeCustom} from '../styles/Theme';
import 'simplebar-react/dist/simplebar.min.css';

import ButtonImgMain from "../components/button/Button_img_main";
import JobCard from "../components/card/Job_card";
import ModalJobView from "../components/Modal/Modal_job_view";

import DashboardIcon from '../assets/Chart-Linear.svg'
import NotFound from '../assets/no-results-found.svg'
import docCreate from '../assets/createDoc.png'
import LinkOffIcon from '../assets/unlink.svg';
import LoaderIcon from '../assets/loader2.gif'

const JobBoard = () => {

    const [openJobView, setOpenJobView] = useState(false)
    const [loader, setLoader] = useState(true)
    const { baseUrl } = useBaseUrlContext();
    const {handleError} = useErrHandleContext()
    const { sucessAlert, failAlert } = useAlertContext();
    const { jobDetails } = useJobDetailContext();
    const [previewPopupData, setPreviewPopupData] = useState({})
    const navigate = useNavigate()

    useEffect(()=>{console.log('previewPopup',Object.keys(previewPopupData).length,  previewPopupData, failAlert)},[previewPopupData,failAlert ])

    //get job list

    const fetchJobData = async ({ pageParam = 0 }) => {

        console.log('queryKey > ', pageParam)

            try{

                const header = {
                    'Authorization': localStorage.getItem('token')
                }
               
                const response = await axios.get(`${baseUrl}/job-descriptions?page=${pageParam}&size=8`, {headers:header})

                const res = response.data
                console.log('res', response);
    
                if(res.code === 200){
                    console.log('jobList', res.data)
                    setLoader(false)
                    return {
                        ...res.data,
                        nextCursor: res.data.lastPage ? null : pageParam + 1, 
                    }
                }
                else{
                    console.error('error xx 1', res)
                    failAlert(true, res.message)
                    setLoader(false)
                    throw new Error(res.message)
                }

            } catch(error) {
                console.error('error xx', error)
                handleError(error)
                //failAlert(true, error.message)
                setLoader(false)
                return [];
            }
        
    }

     //useQuery hook for get job detail

     const {isLoading, data:jobList, fetchNextPage, isFetchingNextPage, hasNextPage, onSuccess} = useInfiniteQuery({

        queryKey: ['fetchJobData'],
        queryFn: fetchJobData,
        cacheTime: 30 * 60 * 1000,
        initialPageParam: 0,
        getNextPageParam: (lastPage) => lastPage?.nextCursor || null,

    })

    useEffect(()=>{console.log('jobList', jobList)}, [jobList])

    //remove pre-open job values from session storage

    useEffect(()=>{

        sessionStorage.removeItem("jobRef")
        sessionStorage.removeItem("jobName")
        sessionStorage.removeItem("jobStatus")
        sessionStorage.removeItem("autoEmailEnable")

    },[])

    // Handle infinite scrolling

    const handleScroll = (e) => {
        const { scrollTop, scrollHeight, clientHeight } = e.target;
        if (scrollHeight - scrollTop <= (clientHeight + 5) && hasNextPage && !isFetchingNextPage) {
            fetchNextPage();
        }
    };

    return(
        <ThemeProvider theme={ThemeCustom}>
            <ModalJobView
                setOpenJobView={setOpenJobView}
                openJobView={openJobView}
                previewPopupData={previewPopupData}
                setPreviewPopupData={setPreviewPopupData}
            />
            <Container maxWidth="xl" className="mt-20 mb-5 pt-5">
                <div className="mb-7 flex justify-between items-center">
                    <Typography variant="textheader2" component={'div'}>Job Board</Typography>
                    <div>
                        <ButtonImgMain 
                            variant='primary' 
                            type='button' 
                            disabled={false} 
                            name='Dashboard'
                            class='capitalize mr-3 '
                            img={DashboardIcon}
                            posision={'right'}
                            onClick={() => navigate('/dashboard')}
                        />
                        <ButtonImgMain 
                            variant='primary' 
                            type='button' 
                            disabled={false} 
                            name='Unlinked CVs'
                            class='capitalize mr-3 '
                            img={LinkOffIcon}
                            posision={'right'}
                            onClick={() => navigate('/unlinked-cvs')}
                        />
                        <ButtonImgMain 
                            variant='primary' 
                            type='button' 
                            disabled={false} 
                            name='Create job'
                            class='capitalize'
                            img={docCreate}
                            posision={'right'}
                            onClick={() => navigate('/create-job')}
                        />
                    </div>
                </div>
                <SimpleBar 
                    className="job-board-height rounded-xl p-0 m-0"
                    onScrollCapture={handleScroll}
                >
                    <Grid container columnSpacing={2}>
                    {jobList?.pages?.[0]?.content?.length > 0 ? (
                        jobList.pages.map((page, pageIndex) => (
                            page.content.map((job) => (
                                <Grid md={4} xl={3} xs="auto" key={job.id} className={'px-2'}>
                                    <JobCard 
                                        isActive={true}
                                        setOpenJobView={setOpenJobView}
                                        job={job} 
                                        setPreviewPopupData={setPreviewPopupData}
                                        jobDetails={jobDetails}
                                    />
                                </Grid>
                            ))
                        ))    
                    ):(
                            loader ? (
                                <div className="w-full flex-col flex justify-center items-center review-unselected">
                                    <img src={LoaderIcon} alt="loading" className="w-[4rem] mb-5"/>
                                    <Typography variant="textheader3" component={'div'}>Loading...</Typography>
                                </div>
                            ):(
                                <div className="w-full flex-col flex justify-center items-center review-unselected">
                                    <img src={NotFound} alt="not found" className="w-[25%] mb-5"/>
                                    <Typography variant="textheader3" component={'div'}>Jobs Not Found!</Typography>
                                </div>
                            )
                        )}    
                    </Grid>
                    {isFetchingNextPage && (
                        <div className="w-full flex-col flex justify-center items-center mt-4">
                            <img src={LoaderIcon} alt="loading" className="w-[2rem]" />
                        </div>
                    )}
                </SimpleBar>
            </Container>
        </ThemeProvider>
        
    )
}

export default JobBoard